module.exports = __webpack_public_path__ + "img/JF-DM.f7f57e8f.png";